export default __webpack_public_path__ + "static/Payload-f7ba40f280fc0111325f6a816431f8a5.svg";